import React, { useState, useContext } from 'react'
import { userContext } from 'global/context/sub-contexts/userContext'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import { getSpinResults } from 'services/spin'
import CountdownTimer from 'components/CountdownTimer'

import './SlotsOverlay.scss'

const SlotsOverlay = ({ slotImages }) => {
  const user_context = useContext(userContext)
  const modal_context = useContext(modalContext)
  const {
    modalContent,
    setSlotsArray,
    setDefaultSlots,
    slotsOverlay,
    setSlotsOverlay,
  } = modal_context || {}
  const { spinsRemaining } = modalContent
  const { points, setPoints } = user_context
  const [spinClicked, toggleSpin] = useState(false)
  const [pointsWon, updatePointsWon] = useState(false)
  const [spinsLeft, updateSpinsLeft] = useState(spinsRemaining)
  const [spinError, updateSpinError] = useState('')
  return (
    <div className={`modal-action slots-overlay${!slotsOverlay ? ' off' : ''}`}>
      <div className="slots-overlay-backdrop"></div>
      <div className="slots-overlay-items-container">
        {spinsLeft > 0 && (
          <>
            <p className="modal-action spins">
              You have {spinsLeft} spin{spinsLeft > 1 && 's'}
            </p>
            <button
              className="modal-action spin-btn"
              onClick={async () => {
                try {
                  const spinResults = await getSpinResults()
                  const { pointsAwarded, items } = spinResults.detail

                  const itemsArray = items.split(',')
                  const targetArray = itemsArray.map(item => {
                    return slotImages.findIndex(
                      slotImage => slotImage.name === item,
                    )
                  })

                  updateSpinsLeft(spinResults.detail.spinsRemaining)
                  setSlotsOverlay(false)
                  toggleSpin(true)

                  //TODO {SMELLY CODE} - has to be a better way to handle this quick change in state / context
                  setDefaultSlots(true)
                  setTimeout(() => {
                    setDefaultSlots(false)
                  }, 10)

                  setSlotsArray(targetArray)
                  updatePointsWon(pointsAwarded)
                  setPoints(points + pointsAwarded)
                } catch (e) {
                  updateSpinError(
                    `Error contacting spin server. Error: ${JSON.stringify(e)}`,
                  )
                }
              }}
            >
              Spin
            </button>
          </>
        )}
        {spinsLeft === 0 && (
          <>
            <p className="modal-action spins">You have no spins left today</p>
            <p className="modal-action time-left">
              Your next free spin: <CountdownTimer spinTime={true} />
            </p>
          </>
        )}
        {!spinClicked && (
          <p className="modal-action prize">
            <span>Grand prize:</span> <span>40,000 points</span>
          </p>
        )}
        {pointsWon && (
          <p className="modal-action points-won">
            You earned {pointsWon} point{pointsWon > 1 && 's'}
          </p>
        )}
        {spinError.length > 0 && <div className="spin-error">{spinError}</div>}
      </div>
    </div>
  )
}

export default SlotsOverlay
